<template>
  <div>
    <!-- add location popup -->
    <vs-popup id="add_location__modal" :style="{ 'z-index': zIndex }" title="Add Location" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-full px-8">
            <!-- strain name -->
            <div class="vx-row mb-2">
              <vs-input icon="icon icon-package" icon-pack="feather" class="w-full" v-model="form.name" label="Location Name" name="Location Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Location Name')">{{ errors.first('Location Name') }}</span>
            </div>

            <!-- location type -->
            <div class="vx-row mb-2" v-if="parentUser.roleId === GROWER">
              <label>Location Type <span class="text-danger">*</span></label>
              <select-2
                autocomplete
                class="w-full"
                @input="(item) => (form.type = item && item.value)"
                :value="form.type"
                label-placeholder="Location Type"
                name="Location Type"
                placeholder="Select Location Type"
                :options="locationOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Location Type')">{{ errors.first('Location Type') }}</span>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="add_location__button" type="relief" @click="addLocation" :disabled="!validateForm || loading">Add Location</vs-button>
              <vs-button color="danger" type="relief" class="text-left" @click="isActive = false">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { locationTypes } from '@/utils/enums'
import { GROWER } from '@/utils/roles'

export default {
  name: 'AddLocation',

  components: {
    Select2
  },

  props: {
    showModal: Boolean
  },

  data() {
    return {
      loading: false,
      GROWER,
      form: {
        name: '',
        type: null
      },
      locationTypes,
      zIndex: 0
    }
  },

  mounted() {
    // set modal zindex
    this.SET_MODAL_ZINDEX(true)

    // set z index
    this.zIndex = this.modal.modalZIndex + this.modal.modalOpens + 1
  },

  // computed
  computed: {
    ...mapState(['modal']),
    ...mapState('auth', ['user', 'parentUser']),

    // validate form
    validateForm() {
      return !this.errors.any()
    },

    locationOptions() {
      return this.locationTypes.reduce((acc, item) => {
        if (this.user.roleId === 6 && item.isGrower === true) {
          acc.push(item)
        } else if (this.user.roleId !== 6 && !item.isGrower) {
          acc.push(item)
        }

        return acc
      }, [])
    },

    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)

        if (!val) {
          // set modal zindex
          this.SET_MODAL_ZINDEX(false)
        }
      }
    }
  },

  // methods
  methods: {
    ...mapMutations(['SET_MODAL_ZINDEX']),
    ...mapActions('location', ['addNewLocaton']),

    // add location
    async addLocation() {
      // validate data
      if (!(await this.$validator.validate())) {
        return false
      }

      this.loading = true
      // add new location
      this.$store
        .dispatch('location/addNewLocaton', this.form)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: res.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.isActive = false
          this.$emit('updateList', res.data)
        })
        .catch(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    // reset form data
    resetForm() {
      this.form = {
        name: '',
        type: null
      }

      this.$nextTick(() => {
        this.errors.clear()
        this.$validator.reset()
      })
    }
  },

  // watch
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add_location__modal  .vs-popup .vs-popup--content',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add_location__modal  .vs-popup .vs-popup--content > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
#add_location__modal {
  .vs-popup {
    width: calc(100% - 80%) !important;
    position: relative;

    .con-vs-loading {
      position: absolute;
    }
  }
}
</style>
